import { TagList } from "@tellescope/ui";

interface TagsCellProps {
  tags: string[];
  availableOptions: string[];
  onAddTag: (tag: string) => void;
  onRemoveTag: (tag: string) => void;
}

export const TagsCell = ({ tags, availableOptions, onAddTag, onRemoveTag }: TagsCellProps) => {
  return (
    <TagList items={tags || []} onRemoveTag={onRemoveTag} onAddTag={onAddTag} availableOptions={availableOptions} />
  );
};
